import { USER } from 'config/api-routes';
import { POST } from 'utils/request';
import { formatResponse } from 'utils/service-helpers';

export default class UserDac7Service {
  static async post(data, opts = {}) {
    const response = await POST(USER.DAC7.POST(), data, opts);

    return formatResponse(response);
  }
}
